export default __webpack_public_path__ + "static/three-miniuts-549e1f7211bed6249356f75b89e59bc8.png";